import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
// import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-wysiwyg-editor',
  templateUrl: './wysiwyg-editor.component.html',
  styleUrls: ['./wysiwyg-editor.component.scss'],
})
export class WysiwygEditorComponent implements OnInit {
  @Input()
  initialContent: string;

  @Output()
  content = new EventEmitter<string>();

  htmlContent: string;
  isBrowser: boolean;

  public editor;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.editor = require('@ckeditor/ckeditor5-build-classic');
    }
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.editorInit();
    }
  }

  onChange(event: any) {
    this.content.emit(event);
  }

  private editorInit(): void {
    this.htmlContent = this.initialContent ?? '';

    this.editor.defaultConfig = {
      allowedContent: true,
      toolbar: {
        items: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'link',
          '|',
          'bulletedList',
          'numberedList',
          '-', // break point
          'outdent',
          'indent',
          '|',
          'undo',
          'redo',
          'mediaEmbed',
        ],
      },
      language: 'en',
      mediaEmbed: {
        previewsInData: true,
      },
    };
  }

  contentChanged() {
    this.content.emit(this.htmlContent);
  }
}
